// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2bylu","title":"Header_title__2gtd_","side":"Header_side__pPi2Q"};